import { render, staticRenderFns } from "./TeaserTab.vue?vue&type=template&id=5258a83f&"
import script from "./TeaserTab.vue?vue&type=script&lang=js&"
export * from "./TeaserTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports